import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h3>Thank you for choosing my Package</h3>
            <h2>Please fill up the form </h2>
        </div>
    );
};

export default Checkout;